import React from 'react';
import { useTranslation } from 'react-i18next';
import { Scale, Box, MapPin, ClipboardCheck } from 'lucide-react';
import DetailTile from './DetailTile';
import { getPropertyValue } from '../../../services/traceability-api';

const FactoryProcessedView = ({ isMobile, data }) => {
    const { t } = useTranslation();
    
    const properties = data?.properties || [];
    const childBatches = data?.childBatches || [];
    
    // Try to get seed/cotton weights from child batches
    const seedBatch = childBatches.find(b => b.batchId?.includes('/SEED') || b.name?.includes('/SEED'));
    const cottonBatch = childBatches.find(b => b.batchId?.includes('/LINT') || b.name?.includes('/LINT') || b.batchId?.includes('/COT') || b.name?.includes('/COT'));
    
    const seedWeight = seedBatch ? `${seedBatch.totalYield || '—'} ${seedBatch.unit || 'kg'}` 
        : getPropertyValue(properties, 'Seed Weight') || '—';
    const cottonWeight = cottonBatch ? `${cottonBatch.totalYield || '—'} ${cottonBatch.unit || 'kg'}` 
        : getPropertyValue(properties, 'Cotton Weight') || getPropertyValue(properties, 'Lint Weight') || '—';
    const warehouseLocation = getPropertyValue(properties, 'Warehouse Location') 
        || getPropertyValue(properties, 'Location') || '—';
    const qualityStatus = getPropertyValue(properties, 'Quality Status') 
        || getPropertyValue(properties, 'Quality') || '—';

    return (
        <div className="animate-fade-in p-0">
            {/* Show child batch info if available */}
            {childBatches.length > 0 && (
                <div className="trace-banner info" style={{ marginBottom: '12px' }}>
                    <div className="side-line"></div>
                    <p>
                        Processing completed. {childBatches.length} output batch{childBatches.length > 1 ? 'es' : ''} created: {' '}
                        {childBatches.map(b => b.name || b.batchId).join(', ')}
                    </p>
                </div>
            )}

            <div className="row g-3">
                <DetailTile isMobile={isMobile} icon={<Scale size={16} />} title="Seed Weight" value={seedWeight} />
                <DetailTile isMobile={isMobile} icon={<Scale size={16} />} title="Cotton/Lint Weight" value={cottonWeight} />
                <DetailTile isMobile={isMobile} icon={<MapPin size={16} />} title="Warehouse Location" value={warehouseLocation} />
                <DetailTile isMobile={isMobile} icon={<ClipboardCheck size={16} />} title="Quality Status" value={qualityStatus} />
            </div>
        </div>
    );
};

export default FactoryProcessedView;
